import { createSelector } from 'reselect'
import findLessonByID from 'helpers/findLessonByID'
import formatLesson from 'redux/selectors/helpers/lesson_formatter'
import { formatLibraryType } from 'helpers/libraryTypeFormatter'
import activitiesCounter from 'helpers/interactive_video/activities_counter'
import entityTypes from 'helpers/enums/entityTypesNames'
import mediaSlide from 'redux/selectors/media_slides/find_media_slide'
import lessonTypes from 'helpers/enums/lessonTypes'
import featureFlagsSelectorCreator from 'redux/selectors/feature_flags/feature_flags_selector'
import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'
import tooltipTypes from 'helpers/enums/tooltipTypes'
import sessionTypes from 'helpers/enums/sessionTypes'
import getAssetById from 'redux/selectors/assets/asset_selector'
import mediaTypes from 'helpers/enums/mediaTypes'

const getPreview = state => state.preview
const getCart = state => state.cart
const getLessons = state => state.lessons
const getPrivateLibraryCurrent = state => state.libraries.current
const ltiSelector = state => state.lti

const featureFlagsSelector = featureFlagsSelectorCreator([
	featureFlagsTypes.VIDEO_LESSON_SHOW_TEACH_BUTTON,
	featureFlagsTypes.INTERACTIVE_VIDEO_PREVIEW_CREDITS_TAB,
	featureFlagsTypes.INTERACTIVE_VIDEO_PREVIEW_STANDARDS_TAB,
])

const collapsedTotalBundleLessons = 5

const private_library_preview_view_selector = createSelector(
	[
		getPreview,
		getCart,
		getLessons,
		getPrivateLibraryCurrent,
		ltiSelector,
		mediaSlide,
		featureFlagsSelector,
		getAssetById,
	],
	(
		preview,
		cart,
		lessons,
		currentPrivateLibrary,
		lti,
		mediaSlide,
		featureFlags,
		getAsset,
	) => {
		let bundleLessons = null
		let moreBundleLessons = false
		let lessonData = null
		let presentationUid = null
		const libraryType = formatLibraryType(lti)
		const entity = findLessonByID(preview.entity_ID, lessons)
		const canShare = entity ? !!entity.data.messages : false
		const canAddToSchoolLibraryId = preview.canAddToSchoolLibraryId
		const canAddToDistrictLibraryId = preview.canAddToDistrictLibraryId
		const lessonAlreadyAdded = preview.lessonAlreadyAdded
		let sessionTypeLaunched = sessionTypes.UNSET
		let bundleId = '', lessonId = '', entityType = '', bundlePresentations = 0
		let promoted = preview.promoted.map(promotedGroup => ({
			...promotedGroup,
			entities: promotedGroup.entities.map(entityID => findLessonByID(entityID, lessons)),
		}))
		if (entity) {
			lessonData = entity
			if (entity.library_object_type === '3') {
				bundleId = entity.data.entityUID
				lessonId = entity.data.defaultNppUID
				bundlePresentations = entity.data.totalPresentations
				entityType = entityTypes.BUNDLE
			} else {
				lessonId = entity.data.entityUID
				entityType = entityTypes.LESSON
				if (entity.data) {
					const isTeachButtonActive = featureFlags[featureFlagsTypes.VIDEO_LESSON_SHOW_TEACH_BUTTON]
					lessonData = formatLesson(
						entity,
						libraryType,
						false,
						tooltipTypes.NONE,
						false,
						false,
						isTeachButtonActive,
					)
					lessonData.canEditLesson = false
					if (lessonData && lessonData.data) {
						presentationUid = lessonData.data.presentation_uid
						if (lessonData.data.type === lessonTypes.VIDEO) {
							const media = mediaSlide(presentationUid)
							const asset = getAsset(media.posterUid, mediaTypes.IMAGE)
							sessionTypeLaunched = preview.sessionLaunchedType
							promoted = promoted.length > 0 ? promoted[0].entities : []
							lessonData.data = {
								...lessonData.data,
								totalActivities: activitiesCounter(media),
								posterUrl: asset ? asset.sizes.medium.path : null,
								handouts: media.handouts,
								isExtraInformationLoaded: preview.isExtraInformationLoaded,
								credits: media.credits,
								shouldShowCreditsTab: featureFlags[featureFlagsTypes.INTERACTIVE_VIDEO_PREVIEW_CREDITS_TAB],
								shouldShowStandardsTab: featureFlags[featureFlagsTypes.INTERACTIVE_VIDEO_PREVIEW_STANDARDS_TAB],
							}
						}
					}
				}
			}

			if (entity.data.entities) {
				if (entity.data.entities.length > collapsedTotalBundleLessons) {
					moreBundleLessons = true
				}
				if (!preview.fullBundleLessons) {
					bundleLessons = entity.data.entities.slice(0, Math.min(entity.data.entities.length, collapsedTotalBundleLessons))
				} else {
					bundleLessons = entity.data.entities
				}
				bundleLessons = bundleLessons.map(entityUID => findLessonByID(entityUID, lessons))
			}
		}
		return {
			lessonData: lessonData ? lessonData : null,
			authorData: entity ? entity.data.author.data : {},
			entity_type: preview.entity_type,
			entity_ID: preview.entity_ID,
			infoOpen: preview.infoOpen,
			isStore: entity ? entity.data.isStore : false,
			bundleId,
			bundlePresentations,
			entityType,
			libraryUID: currentPrivateLibrary.libraryUID,
			lessonId,
			cart: cart.list,
			cart_adding: cart.adding,
			cart_removing: cart.removing,
			bundleLessons,
			moreBundleLessons,
			fullBundleLessons: preview.fullBundleLessons,
			promoted,
			canShare,
			canAddToSchoolLibraryId,
			canAddToDistrictLibraryId,
			lessonAlreadyAdded,
			presentationUid,
			sessionTypeLaunched,
		}
	}
)

export default private_library_preview_view_selector
